import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
// 価格改定によりダイアログ差し替えのため追加した要素なので価格改定後に削除する
import Typography from "material-ui/Typography";
// 価格改定によりダイアログ差し替えのため追加した要素なので価格改定後に削除する
import { LetterPlanType } from "../../../constants/ComponentTypes";
import { isPlanExpired } from "../../../utils/userUtils";
import { connect } from 'react-redux';
import { postUsersMePlans, postPaymentAndPlans } from '../../../redux/actions/AccountSetting';

import DialogModal from '../../common/DialogModal';
// 価格改定のためダイアログ表示内容を差し替えのためコメントアウト
// import PlanDialogInner from './PlanDialogInner';
// import ContactInfoInner from './ContactInfoInner';
// import BillingAddressInner from './BillingAddressInner';
import NotificationBar from '../../Parts/NotificationBar.jsx'
import moment from 'moment';

const styles = () => ({
  // 価格改定のためダイアログ表示内容を差し替えのため元のcssコメントアウト
  // paper: {
  //   maxHeight: 'unset',
  //   background: "#F4F6F9",
  //   width: '90%',
  //   minWidth: '1240px',
  // },

  // ContactInfopaper: {
  //   maxHeight: 'unset',
  //   background: "#F4F6F9",
  //   width: '600px',
  //   margin: 0
  // },

  // contentContainer: {
  //   padding: '20px 25px 30px 25px',
  //   margin: 0,
  //   textAlign: 'left',
  // },

  paper: {
    maxHeight: "unset",
    background: "#F4F6F9",
    width: "600px",
  },

  contentContainer: {
    padding: 0,
    margin: 0,
    minWidth: "600px",
  },

  desc: {
    color: "#181819",
    fontSize: "13px",
  },

  container: {
    background: "#F4F6F9",
    border: "1px solid #D8DBDF",
    width: "100%",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px",
    textAlign: "left",
  },

  contact: {
    background: "#FFFFFF",
    width: "100%",
    boxSizing: "border-box",
    padding: "20px",
    marginTop: "30px",
  },

  link: {
    color: "#1A65FF",
    textDecoration: "none",
  },
});

const PlanDialogContent = {
  PLAN: 1,
  CONTACT_INFO: 2,
  BILLING: 3,
}

class PlanDialog extends React.Component {
  state = {
    content: PlanDialogContent.PLAN,
    selectedPlan: null,
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.isSavingPlan && nextProps.isSavingPlan === false) {
      if (!nextProps.errorMessage) {
        nextProps.toggleDialog();
        //nextProps.displayNotification(nextProps.message);
      }
    }
  }

  toggleContactInfo = () => {
    if (this.state.content === PlanDialogContent.PLAN) {
      this.setState({ content: PlanDialogContent.CONTACT_INFO });
    } else {
      this.setState({ content: PlanDialogContent.PLAN });
    }
  }

  toggleBilling = (plan = null) => {
    if (this.state.content === PlanDialogContent.PLAN) {
      this.setState({
        content: PlanDialogContent.BILLING,
        selectedPlan: plan,
      });
    } else {
      this.setState({ content: PlanDialogContent.PLAN });
    }
  }

  handleChangePlan = (plan = null) => {
    const { user } = this.props;

    if (user && user.user_payment !== null) {
      if (window.confirm('プランを変更します。よろしいですか？')) {
        this.props.postUsersMePlans({
          "letter_plan_id": plan.id,
        })
      }
    } else {
      this.toggleBilling(plan);
    }
  }

  getDialogTitle = () => {
    switch (this.state.content) {
      case PlanDialogContent.PLAN:
        return 'プランを選択'
      case PlanDialogContent.CONTACT_INFO:
        return 'プラン変更申請'
      case PlanDialogContent.BILLING:
        return '請求先情報を編集'
      default:
        return 'プランを選択'
    }
  }

  getCurrentPlanName = (suffix = null) => {
    const { user } = this.props;
    if (user && user.active_plan) {
      let name = user.active_plan.name;
      if (suffix) {
        name = name.endsWith(suffix) ? name : name + suffix;
      }
      return name;
    }

    return '';
  }

  getLatestExpiredPlan = () => {
    const { user } = this.props;
    let latestExpiredPlan = null;
    let latestExpiredAt = 0;
    if (user && user.plans) {
      for (let i = 0, len = user.plans.length; i < len; i++) {
        if (moment(latestExpiredAt) < moment(user.plans[i].pivot.expiration_at)) {
          latestExpiredAt = user.plans[i].pivot.expiration_at;
          latestExpiredPlan = user.plans[i];
        }
      }
    }
    return latestExpiredPlan;
  }

  getExpiredPlanName = () => {
    const latestExpiredPlan = this.getLatestExpiredPlan();

    if (latestExpiredPlan && latestExpiredPlan['name']) {
      return latestExpiredPlan['name'];
    }
    return null;
  }

  getExpiredPlanType = () => {
    const latestExpiredPlan = this.getLatestExpiredPlan();
    if (latestExpiredPlan) {
      return latestExpiredPlan['plan_type'];
    }
    return null;
  }

  getExpiredAt = () => {
    const latestExpiredPlan = this.getLatestExpiredPlan();
    if (latestExpiredPlan && latestExpiredPlan.pivot.expiration_at) {
      return moment(latestExpiredPlan.pivot.expiration_at).format("YYYY/MM/DD HH:mm");
    }
    return null;
  }

  getCurrentPlanId = () => {
    const { user } = this.props;
    if (user && user.active_plan) {
      return user.active_plan.id;
    }

    return null;
  }

  getCurrentPlanType = () => {
    const { user } = this.props;
    if (user && user.active_plan) {
      return user.active_plan.plan_type;
    }

    return null;
  }

  renderErrorMessage = () => {
    if (this.props.errorMessage) {
      return (
        <NotificationBar
          message={this.props.errorMessage}
          type="error"
          open={true}
          autoClose={false}
          disableOnclickListener={true}
          style={{ transform: 'none', boxShadow: 'none', width: '100%', boxSizing: 'border-box', marginBottom: '20px' }}
        >
        </NotificationBar>
      )
    }
  }

  render() {
    const { classes, toggleDialog, isOpen, user } = this.props;

    // ---------価格改定のためダイアログ表示内容を差し替えのためここから追加
    return (
      <DialogModal
        title={'プラン変更'}
        open={user && user.user_role ? false : isOpen} //子アカウントユーザの場合はプランダイアログを表示しない
        onClose={toggleDialog}
        aria-labelledby="pop-up-window"
        maxWidth={false}
        classes={{
          paper: classes.paper,
          contentContainer: classes.contentContainer,
        }}
      >
        <div className={classes.container}>
          {(() => {
            if (isPlanExpired(user)) {
              if (this.getExpiredPlanType() === LetterPlanType.FREE) {
                return (
                  <div className={classes.desc}>
                    無料トライアルは終了しました。有償プランへのアップグレードをご希望される場合は、右下のチャットフォームまたは、下記いずれかの連絡先より、貴社名をご連絡ください。ご質問のみでもけっこうでございます。ご連絡お待ちしております。
                  </div>
                );
              } else {
                return (
                  <div className={classes.desc}>
                    ご利用のプラン「{this.getExpiredPlanName()}」プランは有効期限が{this.getExpiredAt()}までとなっております。引き続きご利用いただくには、右下のチャットフォームまたは、下記いずれかの連絡先より、貴社名をご連絡ください。ご質問のみでもけっこうでございます。ご連絡お待ちしております。
                  </div>
                );
              }
            } else {
              return (
                <React.Fragment>
                  {this.props.isPlanUpdate && (
                    <div className={classes.desc}>{"右下のチャットフォームまたは、下記いずれかの連絡先より、貴社名をご連絡ください。ご質問のみでもけっこうでございます。ご連絡お待ちしております。"}</div>
                  )}
                  {!this.props.isPlanUpdate && (
                    <div className={classes.desc}>現在ご利用中のプランは{this.getCurrentPlanName("プラン")}
                      です。この機能をご利用いただくには、プランの変更が必要です。右下のチャットフォームまたは下記いずれかの方法よりご連絡ください。ご質問のみでもけっこうでございます。ご連絡お待ちしております。</div>
                  )}
                </React.Fragment>
              );
            }
          })()}
          <div className={classes.contact}>
            <Typography variant="body2">
              {"担当者から話を聞きたい: "}
              <a className={classes.link} href={process.env.REACT_APP_SPIR_LINK_SOURCE_OTHER} target="_blank" rel="noopener noreferrer">
                オンラインMTG予約のリンク
              </a>
            </Typography>
            <Typography variant="body2">
              {"メールによるお問い合わせ: "}
              <a className={classes.link} href="mailto:cs@keymanletter.com" target="_blank" rel="noopener noreferrer">
                cs@keymanletter.com
              </a>
            </Typography>
          </div>
        </div>
      </DialogModal>
    );
    // --------価格改定のためダイアログ表示内容を差し替えのためここまで追加

    // 価格改定のためダイアログ表示内容を差し替えのため元のコードをコメントアウト
    // return (
    //   <DialogModal
    //     title={this.getDialogTitle()}
    //     open={user && user.user_role ? false : isOpen} //子アカウントユーザの場合はプランダイアログを表示しない
    //     onClose={toggleDialog}
    //     maxWidth={false}
    //     goBack={this.state.content === PlanDialogContent.PLAN ?
    //       null : () => this.setState({ content: PlanDialogContent.PLAN})}
    //     classes = {{
    //       paper: this.state.content === PlanDialogContent.PLAN ? classes.paper: classes.ContactInfopaper,
    //       contentContainer: classes.contentContainer
    //     }}
    //     >

    //     {this.renderErrorMessage()}

    //     {(()=>{
    //       switch (this.state.content) {
    //         case PlanDialogContent.PLAN:
    //           return (
    //             <PlanDialogInner
    //               getCurrentPlanName={this.getCurrentPlanName}
    //               getExpiredPlanName={this.getExpiredPlanName()}
    //               getExpiredPlanType={this.getExpiredPlanType()}
    //               getExpiredAt={this.getExpiredAt()}
    //               getCurrentPlanId={this.getCurrentPlanId}
    //               isFreePlan={this.isFreePlan}
    //               toggleContactInfo={this.toggleContactInfo}
    //               handleChangePlan={this.handleChangePlan}
    //               isPlanExpired={isPlanExpired(user)}
    //             />);
    //         case PlanDialogContent.CONTACT_INFO:
    //           return <ContactInfoInner />;
    //         case PlanDialogContent.BILLING:
    //           return (
    //             <BillingAddressInner
    //               plan={this.state.selectedPlan}
    //               postPaymentAndPlans={this.props.postPaymentAndPlans}
    //               isSavingPlan={this.props.isSavingPlan}
    //             />);
    //         default:
    //           break;
    //       }
    //     })()}
    //   </DialogModal>
    // );
  }
}

// 価格改定によりダイアログ差し替えのため追加した要素なので価格改定後に削除する
PlanDialog.defaultProps = {
  isPlanUpdate: false,
}

PlanDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  user: PropTypes.object,
  isPlanUpdate: PropTypes.bool,
  postUsersMePlans: PropTypes.func.isRequired,
  postPaymentAndPlans: PropTypes.func.isRequired,
  isSavingPlan: PropTypes.bool,
  errorMessage: PropTypes.string,
};

const mapStateToProps = (state) => {
  return {
    user: state.accountSetting.user,
    errorMessage: state.accountSetting.errorMessage,
    message: state.accountSetting.message,
    isSavingPlan: state.accountSetting.isSavingPlan,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    postUsersMePlans: (data) => dispatch(postUsersMePlans(data)),
    postPaymentAndPlans: (paymentData, planData) => dispatch(postPaymentAndPlans(paymentData, planData)),
  }
};

export default withStyles(styles)(connect(
  mapStateToProps,
  mapDispatchToProps
)(PlanDialog));



// WEBPACK FOOTER //
// ./src/components/SendLetter/dialogs/PlanDialog.jsx